import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { setAddMany, setToString } from './set.utils.js';

function classNames(outputClassNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  args.forEach(function (arg) {
    if (arg && typeof arg === 'object') {
      if (Array.isArray(arg)) {
        setAddMany(outputClassNames, classNames.apply(void 0, [outputClassNames].concat(_toConsumableArray(arg))));
      } else {
        Object.keys(arg).forEach(function (key) {
          if (arg[key]) {
            outputClassNames.add(key);
          }
        });
      }
    } else if (arg) {
      outputClassNames.add(arg);
    }
  });
  return outputClassNames;
}

function className() {
  var outputClassNames = new Set();

  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return setToString(classNames.apply(void 0, [outputClassNames].concat(args)), ' ');
}

export { className, classNames };